import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import FURGAPI from '../../services/api.furg';

import Candidato from '../../components/Candidato';
import { DocumentoArquivos, DocumentoCiencia, DocumentoFormulario } from '../../components/Documentos/';

const Preview = () => {
    const { idproai, cdsexo } = useParams();

    const [info, setInfo] = useState({});
    const [documentos, setDocumentos] = useState({});

    useEffect(() => {
        FURGAPI.call('sischamamentos/Publico/preview', {
            idproai,
            cdsexo,
        })
            .then(resposta => {
                const { documentos, ...dados } = resposta;
                setInfo(dados);
                setDocumentos(documentos);
            })
            .catch(err => console.log(err));
    }, [cdsexo, idproai]);

    return (
        <div className="content">
            <div className="f-header-content">
                <h1 className="f-header-content_title"> Solicitação de matrícula on-line </h1>
                <h2 className="f-header-content__descricao"> Envie seus documentos para realizar sua solicitação de matrícula e comprovação das políticas de ações afirmativas </h2>
            </div>

            <div className="container-fluid">
                <Candidato
                    fl_pendencias={'S'}
                    onDownload={() => {}}
                    situacaoCalendario=""
                    candidato={{
                        modalidade: info.modalidade,
                        chamamento: 1,
                        classificacao: 'N/D',
                        ds_vestibular: 'Descrição do vestibular',
                        chamamentoDesc: 'Descrição do chamamento',
                        nome: 'Nome do candidato',
                        curso: 'Nome do curso',
                    }}
                    vestibular={'Preview'}
                    podeMostrarNotificacaoDeProcessamentoDeferimento={false}
                    podeMostrarNotificacaoDeProcessamentoIndeferimento={false}
                />

                {documentos?.map &&
                    documentos.map(doc => {
                        if (doc.tp_campo === 'f') {
                            return (
                                <DocumentoFormulario
                                    key={doc.id_tipo_documento_candidato}
                                    id={doc.id_tipo_documento_candidato}
                                    descricao={doc.tx_tipo_documento}
                                    campos={doc.campos}
                                    infoPrimeiraFase={{
                                        podeReenviar: true,
                                    }}
                                    etapaAtual="N"
                                />
                            );
                        } else if (doc.tp_campo === 'b') {
                            return (
                                <DocumentoCiencia
                                    key={doc.id_tipo_documento_candidato}
                                    id={doc.id_tipo_documento_candidato}
                                    descricao={doc.tx_tipo_documento}
                                    documento={doc}
                                    confirmado={false}
                                    tipo_envio={'N'}
                                />
                            );
                        }
                        doc.arquivos = doc?.arquivos ?? [];
                        return <DocumentoArquivos key={doc.id_tipo_documento_candidato} {...doc} tipo_envio={'N'} />;
                    })}
            </div>
        </div>
    );
};

export default Preview;
